<template>
  <div class="afdc-h-100">
    <template v-if="queryFuel.includes('ELEC') || queryFuel.includes('HY') || queryFuel.includes('LPG')">
      <div class="afdc-row afdc-fuel-specific-filters">
        <div class="afdc-col-sm-12">
          <template v-if="queryFuel.includes('ELEC')">
            <find-fuel-filters-elec/>
          </template>

          <template v-if="queryFuel.includes('HY')">
            <find-fuel-filters-hy/>
          </template>

          <template v-if="queryFuel.includes('LPG')">
            <find-fuel-filters-lpg/>
          </template>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import FindFuelFiltersElec from '@/components/FindFuelFiltersElec.vue';
import FindFuelFiltersHy from '@/components/FindFuelFiltersHy.vue';
import FindFuelFiltersLpg from '@/components/FindFuelFiltersLpg.vue';
import syncInputRouteQuery from '@/lib/syncInputRouteQuery';

export default {
  components: {
    FindFuelFiltersElec,
    FindFuelFiltersHy,
    FindFuelFiltersLpg,
  },

  computed: {
    queryFuel: syncInputRouteQuery('fuel'),
  },
};
</script>

<style lang="scss">
@import '~bootstrap/scss/_functions.scss';
@import '~bootstrap/scss/_variables.scss';
@import '~bootstrap/scss/_mixins.scss';

.fuel-specific-filters {
  padding: 15px;
  background-color: #bbb;

  margin-bottom: 15px;
  @include media-breakpoint-up(md) {
    margin-bottom: 0px;
    margin-top: -15px;
    height: calc(100% + 15px);
  }
}

.input-note {
  font-size: 12px;
}
</style>
